import styled from "styled-components";

export const StyledMultiSelectorHeader = styled.div`
    padding: 16px 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    background-color: ${(props) => props.theme.primaryBackground};
`;
